import config from "../config";
import { authHeader } from "../helpers";


const createMasterData = (data) => {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(data),
  };

  return fetch(`${config.authApiUrl}/data/add-master-data-bulk`, requestOptions).then(
    handleResponse
  );
}

const updateMasterData = (data, id) => {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(data),
  };

  return fetch(`${config.authApiUrl}/data/update-master-data/${id}`, requestOptions).then(
    handleResponse
  );
}

const deleteMasterData = (id, query) => {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader()
  };
  if (query) {
    return fetch(`${config.authApiUrl}/data/delete-master-data/${id}?${query}`, requestOptions).then(
      handleResponse
    );

  } else {
    return fetch(`${config.authApiUrl}/data/delete-master-data/${id}`, requestOptions).then(
      handleResponse
    );
  }

}

const deleteDepartment = (id) => {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader()
  };

  return fetch(`${config.authApiUrl}/data/delete-department/${id}`, requestOptions).then(
    handleResponse
  );
}

const getDepartments = (query) => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  if (query) {
    return fetch(`${config.authApiUrl}/data/department?${new URLSearchParams(query)}`, requestOptions).then(
      handleResponse
    );
  } else {
    return fetch(`${config.authApiUrl}/data/department`, requestOptions).then(
      handleResponse
    );
  }

};

const getDesignationBydepartment = (id, query) => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  if (query) {
    return fetch(`${config.authApiUrl}/data/designationByDepartment/${id}?${new URLSearchParams(query)}`, requestOptions).then(
      handleResponse
    );
  } else {
    return fetch(`${config.authApiUrl}/data/designationByDepartment/${id}`, requestOptions).then(
      handleResponse
    );
  }

}

const getSkills = () => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${config.authApiUrl}/data/skills`, requestOptions).then(
    handleResponse
  );
};





const handleResponse = (response) => {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      const error = (data && data.message) || response.statusText;
      if(response.status == 401){
        localStorage.clear()
        window.location.pathname = '/'
      }
      return Promise.reject(error);
    }

    return data;
  });
};

export const masterDataService = {
  getDepartments,
  getDesignationBydepartment,
  getSkills,
  createMasterData,
  updateMasterData,
  deleteDepartment,
  deleteMasterData
};
